import request from "utils/request";

//获取验证码
function sendcode(data) {
  return request({
    url: "/sms/sendcode",
    params: data
  });
}

// 个人中心
function memberinfo(data) {
  return request({
    url: "/api/memberinfo",
    params: data
  });
}

// 意见反馈
function feedback(data) {
  return request({
    url: "/api/feedback",
    params: data
  });
}

// 我的咨询
function myconsult(data) {
  return request({
    url: "/api/myconsult",
    params: data
  });
}


export default{
	memberinfo,
	feedback,
	myconsult,
	sendcode
}